import type * as lazyIndex from "./lazyIndex";
import { createLazyComponent, LazyModule, registerLazyOrchestrator, type LazyComponent, } from "owa-bundling";
import { onMailReadingPaneContentLoaded } from "owa-mail-actions/lib/readingPaneActions";
import { type ProactiveReadingPaneSuggestionProps } from "./components/ProactiveReadingPaneSuggestion.Props";

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(() => import(/* webpackChunkName: "CopilotDabProactiveReadingPaneSuggestion" */ "./lazyIndex"), { name: "CopilotDabProactiveReadingPaneSuggestion" });

registerLazyOrchestrator(onMailReadingPaneContentLoaded, lazyModule, m => m.proactiveReadingPaneOrchestrator);

export const LazyProactiveReadingPaneSuggestion: LazyComponent<ProactiveReadingPaneSuggestionProps, undefined, null> = createLazyComponent(lazyModule, m => m.ProactiveReadingPaneSuggestion);
